import { useParams } from "react-router-dom";
import CompanyUserInvites from "./components/CompanyUserInvites";
import CompanyPrograms from "./programs/CompanyPrograms";
import CompanyUsers from "./components/CompanyUsers";
import CompanyDetails from "./components/CompanyDetails";
import CompanyTracks from "./components/CompanyTracks";
import CompanyQuestionnaires from "./components/CompanyQuestionnaires";
import CompanySparks from "./components/CompanySparks";

export default function ViewComapny() {

    const { id } = useParams()

    return(<div className="page-xl-centered standard-padding">
        <CompanyDetails companyId={id}/>
        <div className="v-spacer-3xl"></div>
        <CompanyUsers companyId={id}/>
        <div className="v-spacer-3xl"></div>
        <CompanyUserInvites companyId={id}/>
        <div className="v-spacer-3xl"></div>
        <CompanyPrograms companyId={id}/>
        <div className="v-spacer-3xl"></div>
        <CompanyTracks companyId={id}/>
        <div className="v-spacer-3xl"></div>
        <CompanyQuestionnaires companyId={id}/>
        <div className="v-spacer-3xl"></div>
        <CompanySparks companyId={id}/>
    </div>)
}